/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventaistartresume3Inputs */

const en_eventaistartresume3 = /** @type {(inputs: Eventaistartresume3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue the conversation`)
};

const de_eventaistartresume3 = /** @type {(inputs: Eventaistartresume3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gespräch fortsetzen`)
};

/**
* | output |
* | --- |
* | "Continue the conversation" |
*
* @param {Eventaistartresume3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventaistartresume3 = /** @type {((inputs?: Eventaistartresume3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventaistartresume3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventaistartresume3(inputs)
	return de_eventaistartresume3(inputs)
});
export { eventaistartresume3 as "eventAiStartResume" }